import React from "react";
import queryString from "query-string";
import "./css/greivance.css";
import { Container, Typography, Button } from "@material-ui/core";

import CallToAction from "@material-ui/icons/CallToAction";
import { blue, orange, grey, green, red } from "@material-ui/core/colors";
import { PostData } from "../api/service";
import { Alert, message } from "antd";

export default function CertificateFeesPayment(props) {
  const [certificateRequestId, setCertificateRequestId] = React.useState("");
  const [email, setEmail] = React.useState("");

  const [paymentData, setPaymentData] = React.useState(null);
  const [isPaymentLoaded, setIsPaymentLoaded] = React.useState(false);

  function loadData() {
    let search = props.history.location.search;

    let searchData = queryString.parse(search);

    if (searchData) {
      setCertificateRequestId(searchData.certificate_request_id);
      setEmail(searchData.email);
    }
  }

  React.useEffect(() => {
    loadData();
  }, []);

  function loadPaymentData() {
    // check has payment done first

    PostData(`/get-certificate-payment-string`, {
      certificate_request_id: certificateRequestId,
      email: email,
    }).then((resp) => {
      //

      if (resp.status == true) {
        if (resp.redirect == true) {
          // redirect to site
         // window.location.href = `/paymentresponse-certificate?certificate_request_id=${resp.certificate_request_id}`
        } else {
          
            setPaymentData(resp.data[0]);
            setIsPaymentLoaded(true);
          
        }
      } else {
        // not found
        message.error(resp.status_text);
      }
    });
  }

  React.useEffect(() => {
    if (certificateRequestId != "" && email != "") {
      loadPaymentData();
    }
  }, [certificateRequestId, email]);

  return (
    <div>
      <Container>
        <br />
        <br />
        <div className="container">
          <div className="reg-form">
            <div className="top-bar"></div>
            <div className="form-contents">
              <h3
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
              >
                <div style={{ marginLeft: 10, fontWeight: 700 }}>
                  Fees Payment for Certificate Request
                  <br />
                  <div style={{ fontSize: 16 }}>Dispur College</div>
                </div>
              </h3>
              <hr />
              <Alert banner type="warning" message={<>
                <Typography variant="body2">
                  You will now redirected to the payment page. Please note the
                  following points:
                </Typography>
                <ul>
                  <li>
                    <Typography>
                      Follow the payment procedure very carefully
                    </Typography>
                  </li>
                  <li>
                    <Typography>
                      After a successful payment, an online fees payment receipt
                      will be generated
                    </Typography>
                  </li>
                  <li>
                    <Typography>
                      You can print and save the receipt after the payment
                    </Typography>
                  </li>

                  <li>
                    <Typography>
                      Proceed the <b>"PROCEED TO PAY"</b> Button to continue
                    </Typography>
                  </li>
                </ul></>} />

              {isPaymentLoaded && (
                <>
                {paymentData.order_req && <form method="POST" action="https://api.razorpay.com/v1/checkout/embedded">
                  <input type="hidden" name="key_id" value={paymentData.order_req.key}/>
                  <input type="hidden" name="amount" value={paymentData.order_req.amount}/>
                  <input type="hidden" name="order_id" value={paymentData.order_req.order_id}/>
                  <input type="hidden" name="name" value={paymentData.order_req.name} />
                  <input type="hidden" name="description" value=""/>
                  <input type="hidden" name="image" value={paymentData.order_req.image}/>
                  <input type="hidden" name="prefill[name]" value={paymentData.order_req.prefill.name}/>
                  <input type="hidden" name="prefill[contact]" value={paymentData.order_req.prefill.contact}/>
                  <input type="hidden" name="prefill[email]" value={paymentData.order_req.prefill.email}/>
                  
                  <input type="hidden" name="callback_url" value={paymentData.order_req.callback_url}/>
                  <input type="hidden" name="cancel_url" value={'https://certificate.dispurcollege.ac.in/certificate-fees-response?status=Failed&message=Last Transaction was cancelled by user'}/>
                  <button className="ant-btn ant-btn-primary">Pay Rs {parseFloat(paymentData.order_req.amount) / 100}</button>
                </form>}
                </>
              )}
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
}
